import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enChallenges from '@/locales/en/challenges.json';
import enGeneral from '@/locales/en/general.json';
import enHub from '@/locales/en/hub.json';
import enNews from '@/locales/en/news.json';
import enRiot from '@/locales/en/riot.json';
import enTeams from '@/locales/en/teams.json';
import enTournaments from '@/locales/en/tournaments.json';
import enCr from '@/locales/en/cr.json';
import enDuels from '@/locales/en/duels.json';
import enChess from '@/locales/en/chess.json';
import enCoc from '@/locales/en/coc.json';
import enBackgammon from '@/locales/en/backgammon.json';
import enChinesePoker from '@/locales/en/chinesepoker.json';
import enActiveMatch from '@/locales/en/activeMatch.json';
import enAvatarAssistant from '@/locales/en/avatarAssistant.json';
import enLeaderboard from '@/locales/en/leaderboard.json';
import enOnboarding from '@/locales/en/onboarding.json';
import enMissions from '@/locales/en/missions.json';
import enLimulo from '@/locales/en/limulo.json';

import itChallenges from '@/locales/it/challenges.json';
import itGeneral from '@/locales/it/general.json';
import itHub from '@/locales/it/hub.json';
import itNews from '@/locales/it/news.json';
import itRiot from '@/locales/it/riot.json';
import itTeams from '@/locales/it/teams.json';
import itTournaments from '@/locales/it/tournaments.json';
import itCr from '@/locales/it/cr.json';
import itDuels from '@/locales/it/duels.json';
import itChess from '@/locales/it/chess.json';
import itCoc from '@/locales/it/coc.json';
import itBackgammon from '@/locales/it/backgammon.json';
import itChinesePoker from '@/locales/it/chinesepoker.json';
import itActiveMatch from '@/locales/it/activeMatch.json';
import itAvatarAssistant from '@/locales/it/avatarAssistant.json';
import itLeaderboard from '@/locales/it/leaderboard.json';
import itOnboarding from '@/locales/it/onboarding.json';
import itMissions from '@/locales/it/missions.json';
import itLimulo from '@/locales/it/limulo.json';

/**
 * i18n init. Locales mirror the mobile app namespaces (general, tournaments,
 * teams, news, hub, challenges). v1 ships with `en` and `it` eagerly loaded;
 * additional locales can be added later via `i18next-http-backend` lazy-load
 * if/when the bundle starts to feel heavy.
 *
 * Detection priority:
 *   1. ?lang=… query string (handy for Telegram start_param overrides)
 *   2. Telegram launch param language_code (set by `<AppShell>` once available)
 *   3. browser navigator.language
 */
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'it'],
    ns: ['general', 'tournaments', 'teams', 'news', 'hub', 'challenges', 'riot', 'cr', 'duels', 'chess', 'coc', 'activeMatch', 'backgammon', 'chinesepoker', 'avatarAssistant', 'leaderboard', 'onboarding', 'missions', 'limulo'],
    defaultNS: 'general',
    resources: {
      en: {
        general: enGeneral,
        tournaments: enTournaments,
        teams: enTeams,
        news: enNews,
        hub: enHub,
        challenges: enChallenges,
        riot: enRiot,
        cr: enCr,
        duels: enDuels,
        chess: enChess,
        coc: enCoc,
        activeMatch: enActiveMatch,
        backgammon: enBackgammon,
        chinesepoker: enChinesePoker,
        avatarAssistant: enAvatarAssistant,
        leaderboard: enLeaderboard,
        onboarding: enOnboarding,
        missions: enMissions,
        limulo: enLimulo,
      },
      it: {
        general: itGeneral,
        tournaments: itTournaments,
        teams: itTeams,
        news: itNews,
        hub: itHub,
        challenges: itChallenges,
        riot: itRiot,
        cr: itCr,
        duels: itDuels,
        chess: itChess,
        coc: itCoc,
        activeMatch: itActiveMatch,
        backgammon: itBackgammon,
        chinesepoker: itChinesePoker,
        avatarAssistant: itAvatarAssistant,
        leaderboard: itLeaderboard,
        onboarding: itOnboarding,
        missions: itMissions,
        limulo: itLimulo,
      },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang',
    },
  });

export { i18n };
